import { z } from 'zod';

// Transform a raw PAN into a masked representation by leaving only the first 6 and last 4 digits.
export const RawPanSchema = z
    .string()
    .transform((val) => val.replace(/\D/g, ''))
    .refine((val) => val.length >= 13 && val.length <= 19, {
        message: "Invalid credit card length",
    })
    .transform((val) => {
        const firstSix = val.slice(0, 6);
        const lastFour = val.slice(-4);
        const middleMask = 'X'.repeat(val.length - 10);
        return `${firstSix}${middleMask}${lastFour}`;
    });

// Stored masked PAN values should already be masked when validated at API boundaries.
export const StoredMaskedPanSchema = z
    .string()
    .regex(
        /^(?:\d{6}[A-Za-z*#\s-]{3,9}\d{4}|[A-Za-z*#\s-]{4,12}\d{4})$/,
        'Invalid masked PAN format'
    );
